import React from 'react';

/** Console PageTitleWithFilters — title + inline filter row (view toggle beside filters). */
export default function QawaemPageTitleWithFilters({ children, filters, titleSuffix, className = '' }) {
  return (
    <div className={`page-title-date-row ${className}`}>
      <div className="page-title-date-row__title shrink-0 flex items-center gap-3 flex-wrap">
        {children}
      </div>
      {filters || titleSuffix ? (
        <div className="page-title-date-row__filters flex flex-wrap items-center gap-2 flex-1 min-w-0 justify-start">
          {titleSuffix}
          {filters}
        </div>
      ) : null}
    </div>
  );
}
